// removed by extract-text-webpack-plugin
module.exports = {"SideMenu":"_1yiED9cq0qGbm1YlXAZyQS","SideWidth":"_39-htI6Cuw5Q8_Siy_QMb4","SearchDrawer":"yH2mfW3H3MdcCjx9HiPds","active":"uxmuUIcDRwkx4EZIrSZex","Actionbar":"_2NAuLPqibQhlRQFUxApyIh","Sidebar":"_2PIqwgtxlzvK0uQ7gsFVkS","LogoWhite":"_1HMSWG6ztwgJyyuoGkK5is","LogoColour":"_1Ub5uPCZPWsT7BfOeD9B2Z","Logo":"jgrHhuy4Y1NthLoOx-EeV","Logout":"_35IebXgVtyMFn9ILuX8-sQ","username":"aLo_FX2Xzo0llog8GNkh5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Main/Sidebar.css
// module id = 1365
// module chunks = 0